/** Canonical 27-prefix MSISDN for comparisons and API calls. */
export function canonicalMsisdn(value: string | null | undefined): string | null {
  const digits = (value ?? '').replace(/\D/g, '');
  if (digits.length < 9) return null;
  if (digits.startsWith('0') && digits.length >= 10) {
    return `27${digits.slice(1)}`;
  }
  if (digits.startsWith('27') && digits.length >= 11) {
    return digits.slice(0, 11);
  }
  if (digits.length === 9) {
    return `27${digits}`;
  }
  return digits;
}

/** Resolve the MSISDN to filter XDRs from the account search that loaded the profile. */
export function resolveEdrMsisdnFilter(
  loadedSearchQuery: string | null,
  loadedSearchType: string | null,
  account?: { msisdn?: string | null; msisdn_dma?: string | null } | null,
): string | null {
  const query = (loadedSearchQuery ?? '').trim();
  const queryDigits = query.replace(/\D/g, '');
  const looksLikeIccid = queryDigits.length >= 19;
  const looksLikeMsisdn =
    queryDigits.length >= 9 && queryDigits.length <= 15 && !looksLikeIccid;

  if (loadedSearchType === 'msisdn' && query) {
    return canonicalMsisdn(query);
  }

  if (looksLikeMsisdn && query) {
    return canonicalMsisdn(query);
  }

  return canonicalMsisdn(account?.msisdn || account?.msisdn_dma || null);
}
